import { Outlet, Route } from 'react-router-dom';

import { lazyWithChunkRecovery } from 'helper/lazyWithChunkRecovery';
import { PublicLayout } from 'layouts';
import { MfaRoute, PrivateRoute, UnauthorizedOnlyRoute } from 'components/routes';

import * as routes from './routes';

const AuthenticationSetup = lazyWithChunkRecovery(() => import('screens/Auth/AuthenticationSetup'));
const SetNewPassword = lazyWithChunkRecovery(() => import('screens/Auth/SetNewPassword'));
const Login = lazyWithChunkRecovery(() => import('screens/Auth/Login'));
const LoginMfa = lazyWithChunkRecovery(() => import('screens/Auth/LoginMfa'));
const LoginSSO = lazyWithChunkRecovery(() => import('screens/Auth/LoginSSO'));
const Registration = lazyWithChunkRecovery(() => import('screens/Auth/Registration'));
const NomineeReject = lazyWithChunkRecovery(() => import('screens/NomineeReject'));
const CulturalProjectProcess = lazyWithChunkRecovery(() => import('screens/CulturalProjectProcess'));
const Invitation = lazyWithChunkRecovery(() => import('screens/Invitation'));
const PrivacyPolicy = lazyWithChunkRecovery(() => import('screens/PrivacyPolicy'));
const NomineeReport = lazyWithChunkRecovery(() => import('screens/NomineeReport'));
const FeedbackProcess = lazyWithChunkRecovery(() => import('screens/FeedbackProcess'));

export const publicRoutes = (
  <Route
    element={
      <PublicLayout>
        <Outlet />
      </PublicLayout>
    }
  >
    <Route path={`${routes.invitation}/:invitationId`} element={<Invitation />} />
    <Route path={routes.privacyPolicy} element={<PrivacyPolicy />} />
    <Route path={`${routes.publicCulturalProjectProcess}/:projectId`} element={<CulturalProjectProcess />} />
    <Route path={`${routes.nomineeReject}/:id`} element={<NomineeReject />} />
    <Route path={`${routes.nomineeReport}/:id`} element={<NomineeReport />} />
    <Route path={`${routes.feedbackProcess}/:nominee`} element={<FeedbackProcess />} />

    <Route element={<UnauthorizedOnlyRoute />}>
      <Route path={`${routes.loginScreen}/:invitationId?`} element={<Login />} />
      <Route path={routes.loginSSOScreen} element={<LoginSSO />} />
      <Route path={`${routes.registrationScreen}/:invitationId`} element={<Registration />} />
      <Route path={`${routes.setNewPassword}/:uid/:token`} element={<SetNewPassword />} />
    </Route>

    <Route element={<MfaRoute />}>
      <Route path={routes.authenticationSetup} element={<AuthenticationSetup />} />
      <Route path={routes.loginMfa} element={<LoginMfa />} />
    </Route>

    <Route element={<PrivateRoute />}>
      <Route path={`${routes.culturalProjectProcess}/:projectId/:userId?`} element={<CulturalProjectProcess />} />
    </Route>
  </Route>
);
